export const getOriginName = (name) => {
  if (!name) return '';

  const arr = name.split('.');

  if (arr.length >= 2) return arr.slice(0, -1).join('.');

  return arr.join('.');
};
